import React, { useState } from "react";
import { MdEdit, MdDelete, MdAdd, MdClose } from "react-icons/md";
import "./YantraManage.css";
import YantraManageServices from "../../services/YantraManageServices";
import { useEffect } from "react";
import Loader from "../../components/Loader";
import NoData from "../../components/NoData";
import EditYantraModal from "./modals/EditYantraModal";
import toast from "react-hot-toast";
import { LIVE_YANTRA_IMAGE_URL } from "../../utils/utils";

const YantraManage = () => {
  const [yantras, setYantras] = useState([]);

  const yantraApi = new YantraManageServices();
  const [loader, setLoader] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({});
  const [isSubmiting, setIsSubmitting] = useState(false);

  const handleEdit = (yantra) => {
    setEditingId(yantra.id);
    setFormData(yantra);
  };

  const handleCancel = () => {
    setEditingId(null);
    setFormData({});
  };

  const handleSave = () => {
    // console.log("Saving yantra:", formData);
    const payload = new FormData();
    payload.append("yantra_name", formData.yantra_name);
    payload.append("description", formData.description);
    payload.append("id", formData.id);
    if (formData.yantra_img_file) {
      payload.append("yantra_img", formData.yantra_img_file);
    }
    setIsSubmitting(true);
    yantraApi
      .UpdateYantraDataById(payload)
      .then((response) => {
        if (response.isSuccess) {
          // console.log("Yantra updated successfully:", response.data);
          // Update local state
          // Show success toast
          toast.success(response.message || "Yantra updated successfully");
          if (formData.yantra_img_file) {
            getYantraListData();
          } else {
            setYantras(yantras.map((y) => (y.id === editingId ? formData : y)));
          }
          setEditingId(null);
        }
      })
      .catch((error) => {
        console.error("Error updating yantra:", error);
      })
      .finally(() => {
        setEditingId(null);
        setIsSubmitting(false);
      });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this yantra?")) {
      setYantras(yantras.filter((y) => y.id !== id));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({
          ...formData,
          yantra_img_preview: reader.result,
          yantra_img_file: file,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const getYantraListData = async () => {
    setLoader(true);
    yantraApi
      .getYantraListData()
      .then((response) => {
        if (response.isSuccess) {
          setYantras(response.data);
        } else {
          setYantras([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching yantras:", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    getYantraListData();
  }, []);

  return (
    <div className="yantra-manage">
      {/* <div className="yantra-header">
        <h1>Yantra Management</h1>
         <button className="btn-add">
          <MdAdd /> Add New Yantra
        </button>
      </div> */}

      {loader ? (
        <Loader message="Loading Yantras..." />
      ) : yantras.length === 0 ? (
        <NoData
          message="No Yantras Available"
          subText="Start by creating your first yantra or check back later"
        />
      ) : (
        <div className="yantra-grid">
          {yantras.map((yantra, index) => (
            <div key={yantra.id} className="yantra-card">
              {/* View Mode */}
              <div className="bagd-count">
                <div>{index + 1}</div>
              </div>
              <div className="yantra-image">
                <div className="image-placeholder">
                  <img
                    src={`${LIVE_YANTRA_IMAGE_URL}/${yantra.yantra_img || "default_image.png"}`}
                    alt={yantra.yantra_name}
                    onError={(e) => {
                      e.target.src = `${LIVE_YANTRA_IMAGE_URL}/default_image.png`;
                    }}
                  />
                </div>
              </div>
              <div className="yantra-content">
                <h3 title={yantra.yantra_name}>{yantra.yantra_name}</h3>
              </div>
              <div className="yantra-actions">
                <button
                  className="btn-icon btn-edit"
                  onClick={() => handleEdit(yantra)}
                  title="Edit"
                >
                  <MdEdit />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Edit Modal */}
      <EditYantraModal
        isOpen={editingId !== null}
        formData={formData}
        handleChange={handleChange}
        handleImageChange={handleImageChange}
        handleSave={handleSave}
        handleCancel={handleCancel}
        isSubmiting={isSubmiting}
      />
    </div>
  );
};

export default YantraManage;
